import Grid from '@mui/material/Grid'
import { type FC } from 'react'
import { getPxAsRem } from 'shared/utils'
import { CandidateCompensationPanel } from './CandidateCompensationPanel'
import { CandidateExperiencePanel } from './CandidateExperiencePanel'
import { CandidateOtherAnalystsPanel } from './CandidateOtherAnalystsPanel'
import { CandidatePublicBioPanel } from './CandidatePublicBioPanel'
import { CandidateReferencesPanel } from './CandidateReferencesPanel'
import { CandidateStafferPanel } from './CandidateStafferPanel'

interface CareerProps {}

const Career: FC<CareerProps> = () => {
    return (
        <Grid container spacing={getPxAsRem(24)}>
            <Grid item xs={12}>
                <CandidateExperiencePanel />
            </Grid>

            <Grid item xs={12} md={6}>
                <CandidateReferencesPanel />
            </Grid>

            <Grid item xs={12} md={3}>
                <CandidateStafferPanel />
            </Grid>

            <Grid item xs={12} md={3}>
                <CandidateOtherAnalystsPanel />
            </Grid>

            <Grid item xs={12} md={6}>
                <CandidatePublicBioPanel />
            </Grid>

            <Grid item xs={12} md={6}>
                <CandidateCompensationPanel />
            </Grid>
        </Grid>
    )
}

export default Career
